<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M8.44434 8.44434L15.5553 15.5553"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5303 4.53024C20.8232 4.23734 20.8232 3.76247 20.5303 3.46958C20.2374 3.17668 19.7626 3.17668 19.4697 3.46958L20.5303 4.53024ZM14.5809 8.35834C14.288 8.65124 14.288 9.12611 14.5809 9.419C14.8738 9.7119 15.3487 9.7119 15.6416 9.419L14.5809 8.35834ZM20 3.99991L19.4697 3.46958L14.5809 8.35834L15.1112 8.88867L15.6416 9.419L20.5303 4.53024L20 3.99991Z"
        fill="currentColor"
      />
      <path
        d="M19 8.76337C18.2494 8.77404 15.7637 9.29041 15.2366 8.76337C14.7096 8.23633 15.226 5.75059 15.2366 5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.419 15.6416C9.7119 15.3487 9.7119 14.8738 9.419 14.5809C9.12611 14.288 8.65124 14.288 8.35834 14.5809L9.419 15.6416ZM3.46958 19.4697C3.17668 19.7626 3.17668 20.2374 3.46958 20.5303C3.76247 20.8232 4.23734 20.8232 4.53024 20.5303L3.46958 19.4697ZM8.88867 15.1112L8.35834 14.5809L3.46958 19.4697L3.99991 20L4.53024 20.5303L9.419 15.6416L8.88867 15.1112Z"
        fill="currentColor"
      />
      <path
        d="M8.76337 19C8.77404 18.2494 9.29041 15.7637 8.76337 15.2366C8.23633 14.7096 5.75059 15.226 5 15.2366"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
